import { Link } from 'react-router-dom'
import styled from 'styled-components'

import theme from 'theme_'

const CommonLink = styled(Link)<{ $disabled?: boolean }>`
  color: ${(p) => p.theme.colors.dimmedGold};
  text-decoration: none;
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'auto')};

  :hover,
  :focus-within {
    text-decoration: underline;
    outline: none;
  }
  :focus-visible {
    outline: 1px solid ${theme.colors.horizonOrange};
  }
`
export default CommonLink
